var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Toolbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 13.5625 3 C 12.6445 3 11.844094 3.625625 11.621094 4.515625 L 11.5 5 L 3 5 C 1.895 5 1 5.895 1 7 L 1 12 L 6.2773438 12 C 6.6243437 11.405 7.262 11 8 11 C 8.738 11 9.3756562 11.405 9.7226562 12 L 20.277344 12 C 20.623344 11.405 21.262953 11 22.001953 11 C 22.740953 11 23.377609 11.405 23.724609 12 L 29 12 L 29 7 C 29 5.895 28.105 5 27 5 L 18.5 5 L 18.378906 4.515625 C 18.156906 3.625625 17.357453 3 16.439453 3 L 13.5625 3 z M 2 14 L 2 23 C 2 24.105 2.895 25 4 25 L 26 25 C 27.105 25 28 24.105 28 23 L 28 14 L 23.722656 14 C 23.376656 14.595 22.739 15 22 15 C 21.261 15 20.624344 14.595 20.277344 14 L 9.7226562 14 C 9.3756562 14.595 8.738 15 8 15 C 7.262 15 6.6243438 14.595 6.2773438 14 L 2 14 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Toolbox);
export default __webpack_public_path__ + "static/media/icons8-toolbox.f53608782ff94f7b4892a65172f96aff.svg";
export { ForwardRef as ReactComponent };